<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title class="dodo">قصص </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="900px">
        <v-btn slot="activator" color="primary" dark class="dodo mb-2" @click="dialog = true">إضافة قصة جديدة</v-btn>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="editedItem.title"
                      :rules="titleRules"
                      class="form_label"
                      label="العنوان"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="editedItem.second_title"
                      class="form_label"
                      label="العنوان الثانوي"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="editedItem.writer"
                      class="form_label"
                      label="الكاتب"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-textarea
                      v-model="editedItem.text"
                      class="form_label"
                      label="النص"></v-textarea>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field label="أضف صورة القصة" @click="pickFiles" prepend-icon="fa-solid fa-paperclip"></v-text-field>
                    <input type="file" style="display:none" ref="image" accept="image/*" @change="onFilePicked">
                  </v-flex>
                  
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs6 sm4 md3 v-if="editedItem.image" style="padding:6px; position: relative;">
                        <v-img :src="Url + 'img/small/' + editedItem.image" height="240"></v-img>
                      </v-flex>
                      <v-flex xs6 sm4 md3 v-if="preview" style="padding:6px; position: relative;">
                        <v-img :src="preview" height="240"></v-img>
                        <v-btn absolute top right icon small color="error" @click="removeSelected" style="background: rgba(255,255,255,0.7); margin: 2px;">
                           <v-icon small>fas fa-times</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close" :disabled="saving">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save" :loading="saving" :disabled="saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="stories"
      class="elevation-1"
      :items-per-page="15"
      hide-default-footer
      disable-pagination>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">تعديل</v-icon>
        |
        <v-icon small @click="deleteItem(item)">حذف</v-icon>
      </template>
    </v-data-table>

    <v-pagination
      class="pagination"
      total-visible="20"
      v-model="page"
      color="#c7000b"
      style="position: relative; top: 20px;"
      circle=""
      :length="pageCount">
    </v-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['settings'],
  data() {
    return {
      errors: {},
      page: 1,
      pageCount: 1,
      current_page: 1,
      last_page: 1,
      valid: false,
      dialog: false,
      stories: [],
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'العنوان', value: 'title', sortable: false },
        { text: 'تاريخ الإضافة', value: 'created_at', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      titleRules: [
        (v) => !!v || 'يجب ادخال عنوان القصة',
      ],
      editedIndex: -1,
      editedItem: {
        title: '',
        second_title: '',
        writer: '',
        text: '',
        image: null
      },
      defaultItem: {
        title: '',
        second_title: '',
        writer: '',
        text: '',
        image: null
      },
      file: null,
      preview: null,
      saving: false
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'إضافة قصة جديدة' : 'تعديل قصة'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    page() {
      this.getMoreitems()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    pickFiles() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files || !files.length) return
      this.file = files[0]
      const fr = new FileReader()
      fr.readAsDataURL(this.file)
      fr.addEventListener('load', () => {
        this.preview = fr.result
      })
    },
    removeSelected() {
      this.file = null
      this.preview = null
      // Clear the input value so the same file can be selected again if needed
      if (this.$refs.image) {
        this.$refs.image.value = ''
      }
    },
    getMoreitems() {
      if (this.current_page <= this.last_page) {
        this.current_page = this.page
        this.initialize()
      }
    },
    initialize() {
      axios.get('stories', {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorizations: "Bearer " + this.$store.state.AdminInfo.token
        }
      }).then(d => {
        const payload = d.data
        this.stories = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
        this.last_page = payload.last_page || 1
        this.pageCount = payload.last_page || 1
      })
    },
    editItem(item) {
      this.editedIndex = this.stories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.file = null
      this.preview = null
      this.dialog = true
    },
    deleteItem(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete('stories/' + item.id, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Accept: "application/json",
              Authorizations: "Bearer " + this.$store.state.AdminInfo.token
            },
          }).then(() => {
            this.$swal.fire('Successfully', 'done', "success");
            this.initialize()
          }).catch(() => {});
        }
      })
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.file = null
        this.preview = null
      }, 300)
    },
    save() {
      this.saving = true
      const formData = new FormData()
      formData.append('title', this.editedItem.title)
      if(this.editedItem.second_title) formData.append('second_title', this.editedItem.second_title)
      if(this.editedItem.writer) formData.append('writer', this.editedItem.writer)
      if(this.editedItem.text) formData.append('text', this.editedItem.text)
      
      if (this.file) {
        formData.append('image', this.file)
      }

      if (this.editedIndex > -1) {
        axios.post('stories/' + this.editedItem.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {}).finally(() => { this.saving = false })
      } else {
        axios.post('stories', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {}).finally(() => { this.saving = false })
      }
    },
  }
}
</script>
